import security from "./security-services";

export default class loginController {
    constructor($scope: any, security: security) {

        // Check if banner for new URL should be shown
        const kantegaUrlPattern = /https:\/\/(.*)\.kantega\.no.*/;
        const match = window.location.toString().match(kantegaUrlPattern);

        if (match) {
            $scope.showLegacyUrlWarning = true;
            $scope.showLogin = false;
            if (match[1] === "datafangst-utv") {
                $scope.newUrl = "https://datafangst.utv.vegvesen.no";
            } else if (match[1] === "datafangst-test") {
                $scope.newUrl = "https://datafangst.test.vegvesen.no"
            } else {
                $scope.newUrl = "https://datafangst.vegvesen.no"
            }
        } else {
            $scope.showLegacyUrlWarning = false;
            $scope.showLogin = true;
        }

        $scope.login = function(username: string, password: string) {

            $scope.loginErrorUsernameOrPassword = false;
            $scope.loginErrorAccessDenied = false;
            $scope.checkingPassword = true;
            security.login(username, password).then(() => {
                $scope.checkingPassword = false;
            }, response => {
                const loginError = response.data;
                $scope.checkingPassword = false;
                if (loginError.cause === 'ACCESS_DENIED') {
                    $scope.loginErrorAccessDenied = true;
                } else {
                    $scope.loginErrorUsernameOrPassword = true;
                }
            });
        };
    }
}
loginController.$inject = ['$scope', 'security'];
